export default __webpack_public_path__ + "static/1291-5c9897bedf4a643a207c4690819d9c97.gif";